import { Crown, Check, Lock } from "lucide-react";
import UpgradeButton from "./UpgradeButton";

/**
 * Reusable paywall card shown when a Free user tries to use a Pro feature.
 */
export default function Paywall({
  title = "This is a Pro feature",
  description = "Unlock unlimited events, post-event reports, comparison, and more for $9 / month — cancel anytime.",
  features = [
    "Unlimited saved events",
    "Event comparison",
    "Post-event report & actuals",
    "Printable booth checklist",
  ],
  testid = "paywall-card",
}) {
  return (
    <div className="pop-card p-6 sm:p-10 text-center" data-testid={testid}>
      <span className="inline-grid place-items-center w-14 h-14 rounded-2xl bg-brand-gold/15 text-brand-gold">
        <Lock className="w-7 h-7" strokeWidth={2} />
      </span>
      <div className="inline-flex items-center gap-1.5 pop-pill bg-brand-gold/15 text-brand-gold border border-brand-gold/30 mt-4">
        <Crown className="w-3.5 h-3.5" strokeWidth={2.5} /> Pro feature
      </div>
      <h3 className="font-heading text-2xl sm:text-3xl font-semibold text-brand-ink mt-3 tracking-tight">
        {title}
      </h3>
      <p className="text-sm text-brand-mute mt-2 max-w-md mx-auto">{description}</p>

      <ul className="mt-6 max-w-sm mx-auto text-left space-y-2.5">
        {features.map((f) => (
          <li key={f} className="flex items-start gap-2.5 text-sm text-brand-ink">
            <span className="mt-0.5 w-5 h-5 rounded-full bg-brand-green/10 text-brand-green grid place-items-center shrink-0">
              <Check className="w-3 h-3" strokeWidth={3} />
            </span>
            {f}
          </li>
        ))}
      </ul>

      <div className="mt-6">
        <UpgradeButton variant="primary" label="Subscribe — $9/month" testid={`${testid}-upgrade`} />
      </div>
    </div>
  );
}
